<template>
  <v-card class="pa-3">
    <v-row no-gutters>
      <v-col cols="12" class="modal-header py-3 mb-4">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="10">
            <span class="text-center text-lg d-block font-weight-medium w-full"> اقدامات درمانی </span>
          </v-col>
          <v-col cols="1" class="text-left mt-n2 ml-2">
            <v-icon color="darkColor" @click="closeDialog()">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0" no-gutters>
      <v-col cols="12" v-if="flagShowForm == 1 ||
        (flagShowForm == 2 &&
          ['سقوط', 'سوختگی', 'برخورد با نیروی بی جان', 'حوادث عمدی']
            .includes(diagnosis))" class="data-part">
        <v-row>
          <v-col cols="6">
            <v-row class="mt-1">
              <span class="mr-3">اقدامات مدیریت راه هوایی (A)</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
            </v-row>
            <v-row class="mb-1">
              <v-col cols="12">
                <v-row>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>قبل</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="text-center">
                    <span>اقدامات درمانی</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>بعد</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-for="item in mainAirwayTypeList" :key="item.id" class="mt-n9">
                <v-row>
                  <v-col cols="3" class="mt-n5">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <v-switch v-model="selectedGeneralAction" :value="item.id + 'before'"
                        @click="addItem(item.id, 1)"></v-switch>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="6" class="text-center">
                    <span>{{ item.title }}</span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="3" class="mt-n5">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <v-switch v-model="selectedGeneralAction" :value="item.id + 'after'"
                        @click="addItem(item.id, 0)"></v-switch>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-n5">
              <span class="mr-3">اقدامات مدیریت تنفس (B)</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
            </v-row>
            <v-row class="mb-1">
              <v-col cols="12">
                <v-row>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>قبل</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="text-center">
                    <span>اقدامات درمانی</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>بعد</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-for="item in mainBreathTypeList" :key="item.id" class="mt-n9">
                <v-row>
                  <v-col cols="3" class="mt-n5">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <v-switch v-model="selectedGeneralAction" :value="item.id + 'before'"
                        @click="addItem(item.id, 1)"></v-switch>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="6" class="text-center">
                    <span>{{ item.title }}</span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="3" class="mt-n5">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <v-switch v-model="selectedGeneralAction" :value="item.id + 'after'"
                        @click="addItem(item.id, 0)"></v-switch>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-n5">
              <span class="mr-3">اقدامات مدیریت گردش خون (C)</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
            </v-row>
            <v-row class="mb-1">
              <v-col cols="12">
                <v-row>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>قبل</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="text-center">
                    <span>اقدامات درمانی</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>بعد</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-for="item in mainBloodTypeList" :key="item.id" class="mt-n9">
                <v-row>
                  <v-col cols="3" class="mt-n5">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <v-switch v-model="selectedGeneralAction" :value="item.id + 'before'"
                        @click="addItem(item.id, 1)"></v-switch>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="6" class="text-center">
                    <span>{{ item.title }}</span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="3" class="mt-n5">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <v-switch v-model="selectedGeneralAction" :value="item.id + 'after'"
                        @click="addItem(item.id, 0)"></v-switch>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row class="mt-1">
              <span class="mr-3">بی حرکت سازی اندام</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
            </v-row>
            <v-row class="mb-1">
              <v-col cols="12">
                <v-row>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>قبل</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="text-center">
                    <span>اقدامات درمانی</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>بعد</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-for="item in mainUnmovedTypeList" :key="item.id" class="mt-n9">
                <v-row>
                  <v-col cols="3" class="mt-n5">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <v-switch v-model="selectedGeneralAction" :value="item.id + 'before'"
                        @click="addItem(item.id, 1)"></v-switch>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="6" class="text-center">
                    <span>{{ item.title }}</span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="3" class="mt-n5">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <v-switch v-model="selectedGeneralAction" :value="item.id + 'after'"
                        @click="addItem(item.id, 0)"></v-switch>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-n5">
              <span class="mr-3">اقدامات حرکت اندام ها</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
            </v-row>
            <v-row class="mb-1">
              <v-col cols="12">
                <v-row>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>قبل</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="text-center">
                    <span>اقدامات درمانی</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>بعد</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-for="item in mainMovedTypeList" :key="item.id" class="mt-n9">
                <v-row>
                  <v-col cols="3" class="mt-n5">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <v-switch v-model="selectedGeneralAction" :value="item.id + 'before'"
                        @click="addItem(item.id, 1)"></v-switch>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="6" class="text-center">
                    <span>{{ item.title }}</span>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="3" class="mt-n5">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <v-switch v-model="selectedGeneralAction" :value="item.id + 'after'"
                        @click="addItem(item.id, 0)"></v-switch>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-else cols="12" class="data-part">
        <v-row>
          <v-col cols="12" class="mt-3">
            <v-row>
              <span class="mr-4">اقدامات درمانی</span>
              <v-divider class="mt-3 mr-3 ml-5"></v-divider>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mt-n4">
          <v-col cols="6">
            <v-row class="mb-1">
              <v-col cols="12">
                <v-row>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>قبل</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="text-center">
                    <span>اقدامات درمانی</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>بعد</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row class="mb-1">
              <v-col cols="12">
                <v-row>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>قبل</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="text-center">
                    <span>اقدامات درمانی</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters>
                      <v-spacer></v-spacer>
                      <span>بعد</span>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" v-for="item in allUsesGeneralAction" :key="item.id" class="mt-n9">
            <v-row>
              <v-col cols="3" class="mt-n5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-switch v-model="selectedGeneralAction" :value="item.id + 'before'"
                    @click="addItem(item.id, 1)"></v-switch>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" class="text-center">
                <span>{{ item.title }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="3" class="mt-n5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-switch v-model="selectedGeneralAction" :value="item.id + 'after'"
                    @click="addItem(item.id, 0)"></v-switch>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <template v-if="flagShowForm >= 5">
            <v-col cols="6" v-for="item in modiriatDarmaniZayeman" :key="item.id" class="mt-n9">
              <v-row>
                <v-col cols="3" class="mt-n5">
                  <v-row no-gutters>
                    <v-spacer></v-spacer>
                    <v-switch v-model="selectedGeneralAction" :value="item.id + 'before'"
                      @click="addItem(item.id, 1)"></v-switch>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="6" class="text-center">
                  <span>{{ item.title }}</span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" class="mt-n5">
                  <v-row no-gutters>
                    <v-spacer></v-spacer>
                    <v-switch v-model="selectedGeneralAction" :value="item.id + 'after'"
                      @click="addItem(item.id, 0)"></v-switch>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0 mt-2">
      <v-spacer></v-spacer>
      <v-btn rounded color="darkColor" dark @click="nextDialog()">ثبت و بعدی (داروها)</v-btn>
      <v-btn rounded text class="set-btn mx-1" @click="goToNextStep()">ثبت</v-btn>
      <v-btn text color="darkColor" @click="closeDialog()">انصراف</v-btn>
    </v-row>
  </v-card>
</template>
<script>
import FollowUpPatientStep11Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep11Helper.js';
import PatientGeneralActionMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientGeneralActionMixin.js';
import GeneralActionMixin from '@/Mixins/BaseInformation/GeneralActionMixin';
import ShearedMixin from '@/Mixins/Shared.js';
import SharedHelper from '@/Helpers/Shared';
export default {
  mixins: [
    FollowUpPatientStep11Helper,
    ShearedMixin,
    SharedHelper,
    PatientGeneralActionMixin,
    GeneralActionMixin,
  ],
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
    flagShowForm: {
      type: Number,
      require: true,
      default: null,
    },
    diagnosis: {
      type: String,
      require: true,
      default: '',
    },
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      isGoToNext: false
    }
  },
  methods: {
    mounte: function () {
      this.getAllPatientGeneralActionFunction(this.patientId);
    },
    closeDialog() {
      this.$emit('reloadApiFun');
    },
    nextDialog() {
      // this.$emit('goToNextDialog');
      this.isGoToNext = true;
      this.$nextTick(() => {
        this.goToNextStep();
      });
    },
  },
};
</script>
<style scoped>
.set-btn {
  background: var(--background-color) !important;
  color: var(--dark-color) !important;
  letter-spacing: normal;
  border: 1px solid var(--dark-color);
}

.data-part {
  max-height: 575px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
